module.exports = __webpack_public_path__ + "img/view4.11729240.jpg";